/* global axios */
import ApiClient from './ApiClient';

class ContactTeamsAPI extends ApiClient {
  constructor() {
    super('contacts', { accountScoped: true });
  }

  get({ contactId }) {
    return axios.get(`${this.url}/${contactId}/teams`);
  }

  update({ contactId, teamIds }) {
    return axios.patch(`${this.url}/${contactId}/teams`, { team_ids: teamIds });
  }
}

export default new ContactTeamsAPI();
